<template>
  <v-layout row justify-center>
    <v-dialog v-model="postingPeriodDialogShow" persistent max-width="700px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>-->
      <template v-slot:activator="{ on }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              style="right: 30px; top: 40px"
              class="mt-0 mr-0"
              v-on="on"
              absolute
              dark
              small
              fab
              top
              right
              color="primary"
              @click="openForm()"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Período contábil</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Cadastro de período financeiro</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="postingPeriodForm"
            v-model="validForm"
            lazy-validation
            class="mt-0 pt-0"
          >
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs4 pl-3>
                  <v-text-field
                    v-model="formData.year"
                    label="Ano de referência"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <v-flex xs4 px-3>
                  <v-menu
                    v-model="initDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date_init_formated"
                        label="Data inicial"
                        readonly
                        v-on="on"
                        :rules="$store.state.formRules.required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      type="month"
                      no-title
                      v-model="formData.date_init"
                      @input="initDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 pr-3>
                  <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date_end_formated"
                        label="Data final"
                        readonly
                        v-on="on"
                        :rules="$store.state.formRules.required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      type="month"
                      no-title
                      v-model="formData.date_end"
                      @input="endDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueGrey darken-1" flat @click="closeForm"
            >Cancelar</v-btn
          >
          <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import * as moment from "moment";
const defaultPostingPeriodForm = {
  date_init: "",
  date_end: "",
  year: "",
};
export default {
  watch: {
    postingPeriodDialogShow(v) {
      ///console.log('aaaaaaa')
      this.$refs.postingPeriodForm.resetValidation();
      this.formData = { ...defaultPostingPeriodForm };
      if (v) {
        this.formData = { ...this.editData };
      } else {
        this.formData = { ...defaultPostingPeriodForm };
      }
    },
  },
  computed: {
    date_init_formated: {
      get() {
        return this.formData.date_init
          ? moment(this.formData.date_init).format("MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          this.formData.date_init = moment(value).format("MM/YYYY");
        } else {
          this.formData.date_init = "";
        }
      },
    },
    date_end_formated: {
      get() {
        return this.formData.date_end
          ? moment(this.formData.date_end).format("MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          this.formData.date_end = moment(value).format("MM/YYYY");
        } else {
          this.formData.date_end = "";
        }
      },
    },
  },
  methods: {
    doSave() {
      if (!this.$refs.postingPeriodForm.validate()) {
        return;
      }
      this.updatePostingPeriod(this.formData);
      this.closeForm();
    },
  },
  data() {
    return {
      validForm: true,
      formData: { ...defaultPostingPeriodForm },
      initDateMenu: false,
      endDateMenu: false,
    };
  },
  props: {
    // editDataFinancialIndex: Object,
    updatePostingPeriod: Function,
    postingPeriodDialogShow: Boolean,
    closeForm: Function,
    openForm: Function,
    editData: Object,
    // getFinancialIndex: Function,
    // condominiumsList: Array
  },
};
</script>

<style>
</style>